import { connect } from "react-redux"

import {
    userListRequest,
    userListSearchRequest,
    userListInvalidationRequest,
    userSetFilter,
    userAddNew
} from "../../../actions/user-actions"

import UserListWidget from "./UserListWidget"

const mapStateToProps = ({
    presentation: { users },
    paging,
    authentication
}) => ({
    isFetching: users.isFetchingList || users.isFetchingItem,
    pagingRequest: paging.users[users.searchCriteria] || {},
    nameSearchTerm: users.workingFilterModel.name,
    isEmptySearchValue: users.workingFilterModel.empty,
    canAdd: authentication.permissions.indexOf("w_user") !== -1
})

const mapDispatchToProps = dispatch => ({
    invalidate: pagingRequest => () =>
        dispatch(userListInvalidationRequest(pagingRequest)),
    onFilterSelect: pagingRequest => () =>
        dispatch(userSetFilter(true, pagingRequest.searchCriteria)),
    onSearch: ({ target: { name, value } }) =>
        dispatch(userListSearchRequest(name, value)),
    loadList: () => dispatch(userListRequest()),
    onAdd: () => dispatch(userAddNew())
})

export default connect(mapStateToProps, mapDispatchToProps)(UserListWidget)
